import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface ReckonRedirect {
    errors: any;
    isError: boolean;
}

export default class ReckonRedirectData extends React.Component<RouteComponentProps<{}>, ReckonRedirect> {
    constructor(props: any) {
        super(props);

        this.state = {
            errors: {},
            isError: false
        }
    }

    componentDidMount() {
        this.saveAuth();
    }

    async saveAuth() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        //get the query parameters
        const params = new URLSearchParams(window.location.search);
        var code = "";
        if (params.has('code')) {
            code = params.get('code') ?? "";
        };
        //var realmId = "";
        //if (params.has('realmId')) {
        //    state = params.get('realmId') ?? "";
        //}
        var state = "";
        if (params.has('state')) {
            state = params.get('state') ?? "";
        }

        //decode state parameter
        var actual = JSON.parse(window.atob(state));

        //save the quick books code and realmid
        var authDetails = {
            code: code,
            subId: user.sub
        };

        if (code) {
            //save the quick books authentication details
            axios.post('api/Invoicing/SaveReckonAuthentication', authDetails, {
                headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
            })
            .then(res => {
                //check if there was an error
                if (res.data.isError) {
                    var errors = res.data.messages as any[];
                    errors.map(function (error: any) {
                        toast.error(error.content);
                    });
                    this.setState({ errors: errors, isError: true });
                } else {
                    //redirect to the appropriate page with the code and realmid paramerters
                    var redirect = "/" + actual.page;
                    if (actual.id) {
                        redirect += "/" + actual.id;
                    }
                    this.props.history.push(redirect);
                }
            })
            .catch(error => {
                toast.error(error.message);
            });
        }
    }

    render() {
        return <div>
            <div className={this.state.isError ? "hidden" : "" }>Redirecting...</div>
            <div className={this.state.isError ? "makeitred" : "hidden"}>
                {this.state.errors.length > 0 ?
                    this.state.errors.map((error: any) =>
                        error.content
                    )
                    : ""}
            </div>
             
        </div>;
    }
}